import React from 'react'
import Header from '../../Header';
import Navbar from '../../Navbar';
import Footers from '../../Footers'
import './Delivery.css';
export default function Delivery() {
    return (
        <div>
            <Header />
            <Navbar />
            <div className="Delivery">
                <div className="Delivery-section">
                    <div className="delivery">
                        <h1>
                            DELIVERY & RETURNS</h1>
                    </div>
                    <div className="delivery-heading">
                        <h1 className="ordering">A. SHIPPING AND DELIVERY POLICIES</h1>
                        <br />
                        <div className="faq-item">
                            <h2>Q:1 How does the delivery process work?</h2>
                            <p>All our deliveries are serviced through well-reputed couriers. As soon as your order is dispatched, you will receive an email with your package’s tracking number as well as the name of the courier company that is processing your order. You can use the tracking number to track the status of your package on the courier company’s website.</p>
                        </div>

                        <div className="faq-item">
                            <h2>Q:2 What is the range of locations to which we ship our products?</h2>
                            <p>We ship products throughout India and all orders of Rs.300 and above qualify for free domestic shipping. However, there is a flat shipping charge of Rs.70 if your total order value is less Rs.300.</p>
                        </div>

                        <div className="faq-item">
                            <h2>Q:3 How Can I track my order?</h2>
                            <p>We dispatch most orders within 24 hours (i.e. excluding Sundays and public holidays). You can track your order from your Account section to get an update on where your order is. For your convenience, there is a Track Your Order tab which allows you to see the exact status of your order in real time.</p>
                        </div>
                    </div>
                    <br />
                    {/* Section B */}
                    <div className="faq-section">
                        <h1 className="ordering">B. RETURNS, CANCELLATIONS & EXCHANGES</h1>
                        <br />
                        <div className="faq-item">
                            <h2>Q:1 What is your Online Return Policy?</h2>
                            <p>We believe strongly in our products and their quality and want you to be completely happy with your purchase. If you are disappointed in any way we would like to know. Please see our Returns and Exchange Policy.</p>
                        </div>

                        <div className="faq-item">
                            <h2>Q:2 How do I cancel my order?</h2>
                            <p>Cancellation before shipment: You may cancel your order by going to your Account section and clicking on cancel order. Cancellation post shipment: Please contact our Customer Care on 011- 40691456 (Timings: 10am-6pm IST) and we will be happy to help you with your order cancellation.</p>
                        </div>

                        <div className="faq-item">
                            <h2>Q:3 How will I get a refund for my cancelled orders and how long will this process take?</h2>
                            <p>Please refer to our Returns and Exchange Policy to understand if your order qualifies for a return. For pre-paid orders that have not yet been shipped, your order will be cancelled within 24 hours of cancellation and reflect as per your bank guidelines which is usually within 10 business days. For all orders that have been delivered, we do not entertain Return requests unless the order qualifies as per our Returns and Exchange Policy. For any such requirements, please call our Customer Care on 011-40691456 (Timings: 10am-6pm IST) or email us at contact@upakarma.com</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footers />

        </div>
    );
}
